export default {
      id: "filterNoneSmall-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#filterNoneSmall-usage",
      toString: function () {
        return this.url;
      }
    }